import React from 'react';
import SectionHeading from '../../Components/Shared/SectionHeading';
import offer from '../../Assert/Nestle-Offers.webp'

const PromoOffers = () => {
    return (
        <div className='my-12 px-4'>
            <SectionHeading text={"Digital Payment & Promo Offers"} />
            <div className="grid md:grid-cols-2 grid-cols-1 mt-8 gap-x-8 gap-y-4">
                <div className="">
                    <img src={offer} alt="" />
                </div>
                <div className="">
                    <img src={offer} alt="" />
                </div>
            </div>

        </div>
    );
};

export default PromoOffers;